import React, { useState } from 'react'

import { Button, Modal } from '@st-operations/uikit/src/v2/index.js'

import FileInput from '_components/file-input'

const UploadCSVModal = ({
  title = 'Import topics from file',
  isOpen,
  handleClose = () => {},
  onUpload = () => {},
  isLoading = false,
}) => {
  const [file, setFile] = useState()

  const readFile = () => {
    if (!file) return
    const reader = new FileReader()
    reader.addEventListener('load', () => onUpload(reader.result), false)
    reader.readAsText(file)
  }

  return (
    <Modal onClose={handleClose} isOpen={isOpen}>
      <>
        <h2>CSV Upload</h2>
        <p>{title}</p>
        <FileInput onAddFile={setFile} />
        <Button onClick={readFile} disabled={!file} style={{ marginTop: 36 }} isLoading={isLoading}>
          Import
        </Button>
      </>
    </Modal>
  )
}

export default UploadCSVModal
